//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

import { DataProvider, Dictionary } from "../helpers"

import { Enums } from "../models/common"
import { OpDistributor, OpOperator } from "../models/core"
import { ColumnInfo } from "../models/custom"
import { ActiveDistributorsInfo } from "../models/local"


export class DataProviderDistributor {

    //#region Ctor

    public constructor(private dataProvider: DataProvider) { }

    //#endregion


    //#region Get

    public getDistributorFilter = (columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string) => {
        return this.dataProvider.sendFilterRequestWithSession<OpDistributor>(columns, pageNbr, pageSize, customWhereClause, Enums.ReferenceType.IdDistributor, 'OpxDistributorFilter', 'OpxDistributorFilterResult')
    }

    public getDistributor = (id: number): JQueryPromise<OpDistributor> => {
        return this.dataProvider
            .sendRequestWithSession('OpxGetDistributor', { idDistributor: id }, 'OpxGetDistributorResult')
            .then((result: any) => {
                if (result != null) {
                    const distributor: OpDistributor = new OpDistributor(result)

                    return OpDistributor
                        .loadNavigationProperties(this.dataProvider, [distributor])
                        .then((distributors: OpDistributor[]) => {
                            return _.first(distributors)
                        })
                }

                return null
            })
    }

    //#endregion


    //#region Save

    public saveDistributor = (opObj: OpDistributor): JQueryPromise<OpDistributor> => {
        return this.dataProvider
            .sendRequestWithSession('OpxSaveDistributor', { ToBeSaved: opObj.toJSON() }, 'OpxSaveDistributorResult')
            .then((result: any) => {
                if (result != null) {
                    const distributor: OpDistributor = new OpDistributor(result)

                    return OpDistributor
                        .loadNavigationProperties(this.dataProvider, [distributor])
                        .then((distributors: OpDistributor[]) => {
                            return _.first(distributors)
                        })
                }

                return null
            })
    }

    //#endregion


    //#region Delete

    public deleteDistributor = (opObj: OpDistributor): JQueryPromise<OpDistributor> => {
        return this.dataProvider.sendRequestWithSession('OpxDeleteDistributor', { ToBeDeleted: opObj.toJSON() }, null)
    }

    //#endregion


    public getIdActiveDistributorsLocal = (): number[] => {
        var result: number[] = []
        result = <number[]><any>this.dataProvider.LocalStorage.getFromLocalStorage(Enums.SimaxLocalStorageKey.ActiveIdDistributors)
        if (!result)
            result = []
        return result
    }

    public getIdActiveDistributors = (): JQueryPromise<number[]> => {
        var deferred: JQueryDeferred<number[]> = $.Deferred<number[]>()
        var idActiveDistributor: number[] = this.getIdActiveDistributorsLocal()
        var idActiveDistributorsDeffered = $.Deferred<number[]>()

        if (idActiveDistributor && idActiveDistributor.length > 0) {
            idActiveDistributorsDeffered.resolve(idActiveDistributor)
        }
        else {
            this.dataProvider.System
                .getDictionaries([Enums.ReferenceType.IdDistributor])
                .then(result => {
                    if (result) {
                        var activeDistributors: Dictionary<OpDistributor> = result.tryGetTypedValue<Dictionary<OpDistributor>>(Enums.ReferenceType.IdDistributor)//Dystrybutorzy biezaco wybrany - dla nich wyświetlone zostana dane
                        idActiveDistributor = activeDistributors.values().map(d => {
                            return d.idDistributor
                        })
                        idActiveDistributorsDeffered.resolve(idActiveDistributor)
                    }
                })
        }

        idActiveDistributorsDeffered.promise().then(result => {
            this.setIdActiveDistributorsLocal(result)
            deferred.resolve(result)
        })

        return deferred.promise()
    }

    public setIdActiveDistributorsLocal = (idActiveDistributors: number[]): void => {
        this.dataProvider.LocalStorage.saveToLocalStorage(Enums.SimaxLocalStorageKey.ActiveIdDistributors, idActiveDistributors, 0)
    }

    public getActiveDistributorsInfo = (selectedDistributor: OpDistributor = null): JQueryPromise<ActiveDistributorsInfo> => {
        var deferred: JQueryDeferred<ActiveDistributorsInfo> = $.Deferred<ActiveDistributorsInfo>()
        this.getIdActiveDistributors().then(idActiveDistributors => {
            var activeDistributorsInfo: ActiveDistributorsInfo = new ActiveDistributorsInfo()
            activeDistributorsInfo.count = idActiveDistributors ? idActiveDistributors.length : 0
            if (idActiveDistributors && idActiveDistributors.length > 0) {
                if (idActiveDistributors.length > 1) {
                    activeDistributorsInfo.multiple = true
                }
                else if (idActiveDistributors.length == 1) {
                    activeDistributorsInfo.multiple = false
                    var loggedOperator: OpOperator = this.dataProvider.LocalStorage.getLoggedOperator()
                    if (selectedDistributor)
                        activeDistributorsInfo.singleActiveDistributor = selectedDistributor
                    else if (loggedOperator && loggedOperator.distributor && loggedOperator.idDistributor == idActiveDistributors[0])//Oszczedzamy odwolanie do serwisu
                        activeDistributorsInfo.singleActiveDistributor = loggedOperator.distributor
                    else {
                        this.getDistributor(idActiveDistributors[0]).then(result => {
                            if (result)
                                activeDistributorsInfo.singleActiveDistributor = result
                        })
                    }
                }
            }
            activeDistributorsInfo.proccessDone = true
            deferred.resolve(activeDistributorsInfo)
        })

        return deferred.promise()
    }

    // Public Methods End
}